var _a, _b, _c, _d, _e, _f;
import { PaymentCurrencyTypes, SubscriptionTerms, } from '../models';
export var dashpivotPricingInputs = {
    standard: (_a = {},
        _a[PaymentCurrencyTypes.AUD] = 32,
        _a[PaymentCurrencyTypes.USD] = 32,
        _a[PaymentCurrencyTypes.EUR] = 26,
        _a[PaymentCurrencyTypes.GBP] = 26,
        _a[PaymentCurrencyTypes.ZAR] = 280,
        _a),
    pro: (_b = {},
        _b[PaymentCurrencyTypes.AUD] = 54,
        _b[PaymentCurrencyTypes.USD] = 54,
        _b[PaymentCurrencyTypes.EUR] = 43,
        _b[PaymentCurrencyTypes.GBP] = 43,
        _b[PaymentCurrencyTypes.ZAR] = 432,
        _b),
    enterprise: (_c = {},
        _c[PaymentCurrencyTypes.AUD] = 76,
        _c[PaymentCurrencyTypes.USD] = 76,
        _c[PaymentCurrencyTypes.EUR] = 60.8,
        _c[PaymentCurrencyTypes.GBP] = 60.8,
        _c[PaymentCurrencyTypes.ZAR] = 608,
        _c),
};
export var sitematePricingInputs = {
    pro: (_d = {},
        _d[PaymentCurrencyTypes.AUD] = 15,
        _d[PaymentCurrencyTypes.USD] = 15,
        _d[PaymentCurrencyTypes.EUR] = 11,
        _d[PaymentCurrencyTypes.GBP] = 11,
        _d[PaymentCurrencyTypes.ZAR] = 120,
        _d),
    enterprise: (_e = {},
        _e[PaymentCurrencyTypes.AUD] = 20,
        _e[PaymentCurrencyTypes.USD] = 20,
        _e[PaymentCurrencyTypes.EUR] = 15,
        _e[PaymentCurrencyTypes.GBP] = 15,
        _e[PaymentCurrencyTypes.ZAR] = 152,
        _e),
};
export var basePricing = {
    dashpivot: dashpivotPricingInputs,
    sitemate: sitematePricingInputs,
};
export var currencyConverterFactor = {
    AUD: 1,
    USD: 1,
    EUR: 0.8,
    GBP: 0.8,
    ZAR: 8,
};
export var termDiscounts = (_f = {},
    _f[SubscriptionTerms.Monthly] = 0,
    _f[SubscriptionTerms.OneYear] = 0.1,
    _f[SubscriptionTerms.TwoYears] = 0.1,
    _f[SubscriptionTerms.ThreeYears] = 0.1,
    _f[SubscriptionTerms.FiveYears] = 0.1,
    _f);
export var tierDiscounts = {
    dashpivot: {
        1: 0,
        2: 2,
        3: 4,
        4: 6,
        5: 8,
        6: 10,
        7: 12,
        8: 13,
        9: 14,
        10: 15,
    },
    sitemate: {
        1: 0,
        2: 1.5,
        3: 3,
        4: 4,
        5: 4.5,
        6: 5,
        7: 5.25,
        8: 5.5,
        9: 5.75,
        10: 6,
    },
};
var tierByPaidLicenses = [
    { range: 6, tier: 1 },
    { range: 11, tier: 2 },
    { range: 31, tier: 3 },
    { range: 51, tier: 4 },
    { range: 101, tier: 5 },
    { range: 201, tier: 6 },
    { range: 501, tier: 7 },
    { range: 1001, tier: 8 },
    { range: 2001, tier: 9 },
];
export var getTierByAmountOfPaidLicenses = function (amountOfPaidLicenses) {
    var lastTier = 10;
    var tierObject = tierByPaidLicenses.find(function (tier) { return amountOfPaidLicenses < tier.range; });
    return tierObject ? tierObject.tier : lastTier;
};
